export default __webpack_public_path__ + "static/media/close.a63b94d9.svg";